export default __webpack_public_path__ + "static/media/Keegan Consulting Group.9831a340.png";